import { all, call, takeEvery, spawn } from 'redux-saga/effects';
import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { ec, ga } from 'helpers/multitrack';
import { segment } from 'helpers/segment';
import { userActionCampaign } from 'redux/saga/entities/bound';
import { writeLocalStorage } from 'redux/saga/helpers/local-storage';
import { deepExtract } from 'helpers/deep';

export const LOAD_INVITE_A_FRIEND = 'LOAD_INVITE_A_FRIEND';

export const loadInviteAFriend = token => ({ type: LOAD_INVITE_A_FRIEND, token });

export function* doLoadInviteAFriend(client, { token }) {
  const [referral] = yield all([
    call(fetchEntityIfNeeded, userActionCampaign, [client, token], { key: token }),
    call(writeLocalStorage, 'invite_a_friend--conversion', { token }),
  ]);
  const hasSchedule = deepExtract('schedule', referral);
  if (hasSchedule) {
    const variantName = deepExtract('variant.variationName', referral, 'Original');
    const variantId = deepExtract('variant.variationId', referral);
    yield all([
      call(segment.track, 'IaF - Landing Page Shown', {
        campaign_id: deepExtract('campaign.campaign_id', referral),
        referral_id: deepExtract('referral_id', referral),
        spots: deepExtract('schedule.availability.status', referral),
        venue_id: deepExtract('schedule.venue.id', referral),
        class_id: deepExtract('schedule.class.id', referral),
        schedule_id: deepExtract('schedule.id', referral),
        promo_code: token,
        variant_name: variantName,
        variant_id: variantId,
      }),
      call(segment.track, 'IAF - Landing page', {
        action: variantName,
        label: `${variantName} : ${variantId}`,
      }),
      spawn(ec, 'IaF - Landing Page Shown', {
        campaign_id: deepExtract('campaign.campaign_id', referral),
        referral_id: deepExtract('referral_id', referral),
        spots: deepExtract('schedule.availability.status', referral),
        venue_id: deepExtract('schedule.venue.id', referral),
        class_id: deepExtract('schedule.class.id', referral),
        schedule_id: deepExtract('schedule.id', referral),
        promo_code: token,
        variant_name: variantName,
        variant_id: variantId,
      }),
      spawn(ga, 'IAF - Landing page', variantName, `${variantName} : ${variantId}`),
    ]);
  }
}

export function* watchInviteAFriendSagas(client) {
  yield takeEvery(LOAD_INVITE_A_FRIEND, doLoadInviteAFriend, client);
}
